const checkDomain = function (url) {
  if (url.indexOf('//') === 0) { url = location.protocol + url; }
  if (url.indexOf('mailto:') === 0) { return false; }
  if (url.toLowerCase().includes('qonto.com')) { return false; }
  if (url.toLowerCase().includes('qonto.eu')) { return false; }

  return true;
};

// return true if url include ':' or '//' (mailto: or protocol)
// and domain is accepter
const isExternal = function (url) {
  if (url === undefined) { return false; }
  return ((url.indexOf(':') > -1 || url.indexOf('//') > -1) && checkDomain(url));
};

// Assertion about isExternalBehavior

// console.log(isExternal('http://google.com'), true); //
// console.log(isExternal('https://google.com'), true); //
// console.log(isExternal('//google.com'), true); // (no protocol)
//
// console.log(isExternal('http://qonto.com/port'), false); // (same domain, different port)
// console.log(isExternal('https://qonto.com/secure'), false); // (same domain, https)
// console.log(isExternal('mailto:philippetring@gmail.com'), false); //
// console.log(isExternal('http://qonto.com/about'), false); // (same domain, different page)
// console.log(isExternal('HTTP://QONTO.COM/about'), false); // (same domain, but different casing)
// console.log(isExternal('//qonto.com/about'), false); // (same domain, no protocol)
// console.log(isExternal('/about'), false); //
// console.log(isExternal('image.jpg'), false); //
// console.log(isExternal('#anchor'), false); //
// console.log(isExternal(''), false); //
// console.log(isExternal('https://app.qonto.com'), false); //
// console.log(isExternal('http://app.qonto.com'), false); //
// console.log(isExternal('https://welcome.qonto.com'), false); //
// console.log(isExternal('http://welcome.qonto.com'), false); //
// console.log(isExternal('http://welcome.qonto.eu'), false); //
// console.log(isExternal('http://qonto.eu'), false); //

export {
  isExternal
};
